import React from 'react'
import ReactPaginate from 'react-paginate';
import { LeftArrowSvg } from '../../../svgFiles/LeftArrowSvg';
const Pagination = ({totalPages,onPageChange}) => { 
  return (
    <div className='pagination'>
        <ReactPaginate
        breakLabel="..."
        nextLabel="next >"
        onPageChange={(e)=>{onPageChange(e.selected + 1)}}
        pageRangeDisplayed={5}
        pageCount={totalPages}
        previousLabel="< previous"
        renderOnZeroPageCount={null}
      />
    </div>
  )
}

export default Pagination